import {
    SET_PROPERTY_TITLE_NOTES,
    REMOVE_PROPERTY_TITLE_NOTES
} from "../../types";

const initialState = { TitleNotes: [] };

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_PROPERTY_TITLE_NOTES:
            return {
                ...state,
                TitleNotes: payload
            };
        case REMOVE_PROPERTY_TITLE_NOTES:
            return {
                ...state,
                TitleNotes: []
            };
        default:
            return state;
    }
}